var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "users",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fd9d1e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "users-2",
    "data-name": "users",
    d: "M3,8.25a2,2,0,1,0-2-2A2,2,0,0,0,3,8.25Zm14,0a2,2,0,1,0-2-2A2,2,0,0,0,17,8.25Zm1,1H16a1.994,1.994,0,0,0-1.409.581,4.571,4.571,0,0,1,2.347,3.419H19a1,1,0,0,0,1-1v-1A2,2,0,0,0,18,9.25Zm-8,0a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,10,9.25Zm2.4,1h-.259a4.832,4.832,0,0,1-4.281,0H7.6A3.6,3.6,0,0,0,4,13.85v.9a1.5,1.5,0,0,0,1.5,1.5h9a1.5,1.5,0,0,0,1.5-1.5v-.9A3.6,3.6,0,0,0,12.4,10.25ZM5.409,9.831A1.994,1.994,0,0,0,4,9.25H2a2,2,0,0,0-2,2v1a1,1,0,0,0,1,1H3.059A4.583,4.583,0,0,1,5.409,9.831Z",
    transform: "translate(9.812 10.75)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.97cc48e15f1ce4da3dcf747ecc38f59b.svg";
export { ForwardRef as ReactComponent };